import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { PartnerCardDto } from '@interfaces/partner-income-tax/responses/partner-income-tax.response';
import { PartnerIncomeTaxSelection } from '@features/dashboard/performance/pages/dfp/components/partner-income-tax/partner-income-tax-state.service';
import {
  PARTNER_BADGE_TAGS,
  formatCompactMoney,
  formatPersonName,
  formatSharePercent,
} from '@features/dashboard/performance/pages/dfp/components/partner-income-tax/utils/partner-income-tax-format.util';

/** Cards dos sócios mais o card escuro da visão consolidada (protótipo, `_socios`). */
@Component({
  selector: 'app-pit-partner-selector',
  standalone: true,
  templateUrl: './partner-selector.component.html',
  styleUrl: './partner-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerSelectorComponent {
  readonly partners = input.required<PartnerCardDto[]>();
  readonly selection = input<PartnerIncomeTaxSelection | null>(null);
  /** Política de garantias definida: sem ela o card mostra as dívidas no lugar da garantia livre. */
  readonly policyDefined = input(true);
  /** Dívidas por sócio (do comparativo do consolidado), em reais. */
  readonly debtsByPerson = input<Record<string, number>>({});

  readonly selectPartner = output<string>();
  readonly selectConsolidated = output<void>();

  protected readonly badges = PARTNER_BADGE_TAGS;
  protected readonly money = formatCompactMoney;
  protected readonly personName = formatPersonName;

  protected debts(personId: string): string {
    const value = this.debtsByPerson()[personId];
    if (value == null) return '—';
    return value === 0 ? 'Nenhuma' : formatCompactMoney(value);
  }

  protected isSelected(personId: string): boolean {
    const selection = this.selection();
    return selection?.kind === 'partner' && selection.personId === personId;
  }

  protected isConsolidated(): boolean {
    return this.selection()?.kind === 'consolidated';
  }

  protected describe(partner: PartnerCardDto): string {
    const parts = [
      partner.sharePercent != null
        ? `${formatSharePercent(partner.sharePercent)} do capital`
        : null,
      partner.role,
    ].filter(Boolean);
    return parts.join(' · ');
  }
}
